import { TManagementTabs } from 'models/management.models'
import {
  managementTabComponents,
  managementTabs,
} from 'lib/utils/Management/management.utils'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { selectManagementActiveTab } from 'store/Management/management.selectors'
import { setManagementActiveTab } from 'store/Management/management.reducer'
import SydTabs from 'components/Shared/SydTabs/SydTabs'
import useStoreEvent from 'hooks/Shared/useStoreEvent'
import { STORE_EVENT_TYPES } from 'lib/enums/shared.enums'
import { MANAGEMENT_TABS } from 'lib/enums/management.enums'

const ManagementContainer = () => {
  const dispatch = useAppDispatch()

  const managementActiveTab = useAppSelector(selectManagementActiveTab)

  const ActiveTabComponent = managementTabComponents[managementActiveTab]

  const handleChangeTab = (
    _: React.ChangeEvent<{}>,
    newTab: TManagementTabs
  ) => {
    dispatch(setManagementActiveTab(newTab))
  }

  useStoreEvent(STORE_EVENT_TYPES.ACTIVE_WORKSPACE_CHANGE, () =>
    dispatch(setManagementActiveTab(MANAGEMENT_TABS.WORKSPACES))
  )

  return (
    <div className="management-container">
      <SydTabs
        tabs={managementTabs}
        activeTab={managementActiveTab}
        onChangeTab={handleChangeTab}
      />
      <ActiveTabComponent />
    </div>
  )
}

export default ManagementContainer
